<i18n>
{
  "de": {
    "followedArtists": "Deine Lieblingskünstler",
    "noFollowedArtists": "Du folgst bisher niemandem."
  },
  "en": {
    "followedArtists": "Your favorite artists",
    "noFollowedArtists": "You are not following anyone yet."
  }
}
</i18n>

<template>
  <section
    v-if="isAuthenticated && dataAvailable"
    class="followship"
  >
    <nav v-if="!followship.users.length">
      <a class="panel-block">
        <p>
          <strong>{{ $t('noFollowedArtists') }}</strong>
        </p>
      </a>
    </nav>
    <nav
      v-if="followship.users.length"
      class="roster"
    >
      <div class="roster-images">
        <figure
          v-for="(u, index) in followship.users"
          :key="index"
          class="avatar"
          @click.stop.prevent="selectUser(u.artist.nickname, u.artist.urlAlias)"
        >
          <div class="avatar-image">
            <img
              v-if="getAvatarPicture(u.artist)"
              :src="getAvatarPicture(u.artist)"
              alt="Avatar"
            >
            <div
              v-else
              class="avatar-placeholder"
            />
          </div>
          <figcaption class="artist-name">
            {{ u.artist.nickname }}
          </figcaption>
        </figure>
      </div>
    </nav>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      selectedNickname: ''
    }
  },
  computed: {
    ...mapState(['isAuthenticated', 'followship', 'mobileMenuOpen']),
    dataAvailable() {
      return this.followship &&
        this.followship.users &&
        this.followship.users.length > 0
    }
  },

  methods: {
    async goProfile(alias) {
      const locale = await this.$i18n.locale
      if (this.mobileMenuOpen) {
        this.$store.dispatch('toggleMobileMenuOpen')
      }
      this.$router.push({
        name: `id-posts___${locale}`,
        params: {
          id: alias,
          scrollTo: {
            target: 'profile-navigation'
          }
        }
      })
    },
    getAvatarPicture(artist) {
      if (
        !artist ||
        !artist.profile ||
        !artist.profile.imgs ||
        !artist.profile.imgs.avatar
      ) {
        return false
      }
      if (typeof artist.profile.imgs.avatar === 'string') {
        return artist.profile.imgs.avatar
      }

      if (!artist.profile.imgs.avatar.name) {
        return false
      }

      return `/services/media/image/${artist._id}/${artist.profile.imgs.avatar.name}/32/32/image.webp`
    },
    selectUser(nickname, alias) {
      this.selectedNickname = nickname
      this.goProfile(alias)
    }
  }
}
</script>

<style lang="scss">
@import 'assets/sass/_variables';

.followship {
  .roster {
    display: flex;
    flex-direction: column;
    align-items: center;

    .roster-images {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      justify-content: center;
      max-width: 100%;

      .avatar {
        display: flex;
        flex-direction: column;
        align-items: center;

        .avatar-image {
          display: flex;
          justify-content: center;
          padding: 0.25rem;
          border: 2px solid transparent;
          border-radius: 50%;
          transition: all 150ms ease-in-out;
          cursor: pointer;

          &:hover {
            border-color: $primary;
            transform: scale(1.1);
          }

          &:focus {
            outline: none;
            border-color: $primary;
          }
        }

        img {
          width: 32px;
          height: 32px;
          border-radius: 50%;
        }

        .avatar-placeholder {
          width: 32px;
          height: 32px;
          background-color: #ccc;
          border-radius: 50%;
        }

        .artist-name {
          margin-top: 8px;
          font-size: 12px;
          font-weight: 500;
          color: $gt-blue-dark;
          word-wrap: break-word;
          line-height: 1.2;
          max-height: 2.4em;
          overflow: hidden;
          text-align: center;
        }
      }
    }
  }
}
</style>
